import { configureStore } from "@reduxjs/toolkit";
import cardDetailReducer from "./slice/cardDetailSlice";
import uiReducer from "./slice/uiSlice";

const store = configureStore({
  reducer: {
    cardDetail: cardDetailReducer,
    ui: uiReducer,
  },
});

export default store;
